import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

export default function AddBlog() {
  const navigate = useNavigate();
  const fileRef = useRef(null);

  const [form, setForm] = useState({
    title: "",
    image: "",
    link: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleUploadClick = () => {
    fileRef.current.click();
  };

  // ⚠️ Backend does NOT support image upload yet
  // So we only keep URL-based image handling
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    alert("Image upload API not implemented yet. Please use Image URL.");
  };

 


const handleSubmit = async () => {
  if (!form.title || !form.image || !form.link) {
    toast.error("All fields are required");
    return;
  }

  if (form.title.trim().length < 4) {
    toast.error("Blog title must be more than 3 characters");
    return;
  }

  try {
    const payload = {
      blogTitle: form.title,
      imageURL: form.image,
      blogLink: form.link,
    };

    await axios.post(
      "https://api.livestockify.com/api/admin/blogs",
      payload
    );

    toast.success("Blog added successfully");

    navigate("/blog");
  } catch (error) {
    console.error("Failed to add blog:", error);
    toast.error("Failed to add blog. Please try again.");
  }
};


  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />
      <Toaster position="top-right" />

      {/* Main */}
      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-6">
        <h2 className="text-green-700 font-semibold mb-8">Add Blog</h2>

        <div className="max-w-2xl mx-auto space-y-6">
          {/* Blog Title */}
          <div className="flex flex-col md:flex-row md:items-center gap-3">
            <label className="w-32 text-sm font-medium">Blog Title</label>
            <input
              name="title"
              value={form.title}
              onChange={handleChange}
              placeholder="Enter Blog Title"
              className="border rounded-md px-3 py-2 w-full"
            />
          </div>

          {/* Image URL */}
          <div className="flex flex-col md:flex-row md:items-center gap-3">
            <label className="w-32 text-sm font-medium">Image URL</label>

            <div className="flex gap-2 w-full">
              <input
                name="image"
                value={form.image}
                onChange={handleChange}
                placeholder="Enter Image URL"
                className="border rounded-md px-3 py-2 flex-1"
              />
              <input
                type="file"
                ref={fileRef}
                onChange={handleFileChange}
                className="hidden"
                accept="image/*"
              />
            </div>
          </div>

          {/* Blog Link */}
          <div className="flex flex-col md:flex-row md:items-center gap-3">
            <label className="w-32 text-sm font-medium">Blog Link</label>
            <input
              name="link"
              value={form.link}
              onChange={handleChange}
              placeholder="Enter Blog Link"
              className="border rounded-md px-3 py-2 w-full"
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-4 pt-6">
            <button
              onClick={() => navigate("/blog")}
              className="border px-6 py-2 rounded-md"
            >
              Cancel
            </button>

            <button
              onClick={handleSubmit}
              className="bg-green-500 text-white px-6 py-2 rounded-md"
            >
              Add Blog
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
